import {useSelector} from 'react-redux';

import {getShippingCountry} from '../../store/selectors/shippingAddress/shippingAddress';
import {getSelectedShippingMethod} from '../../store/selectors/shippingMethods/shippingMethods';

/**
 * Checking conditions for shipping protection
 *
 * @return {boolean} is eligible
 */
export const useShippingProtectionEligible = () => {
    const selectedShipping = useSelector(getSelectedShippingMethod);
    const shippingCountry = useSelector(getShippingCountry);

    return shippingCountry === 'US' && Boolean(selectedShipping?.shippingProtectionPrice);
};
